import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 sm:gap-4" }
const _hoisted_2 = { class: "flex items-center gap-2 sm:gap-4" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block" }, "Previous", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block" }, "Next", -1)

import { Button, Select } from 'ant-design-vue';
import { capitalize, ref, watch } from 'vue';
import { RouterLink } from 'vue-router';
import { ArrowLeftOutlined, ArrowRightOutlined, HomeOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChapterControl',
  props: {
    homeURL: {},
    className: {},
    chapter: {},
    chapters: {}
  },
  emits: ["onFetch"],
  setup(__props: any, { emit }) {

const props = __props;





const _chapter = ref(props.chapter);

function selectOptions(texts: string[]) {
	return texts.map((text) => {
		return {
			value: text,
			title: text,
			label: 'Chapter ' + capitalize(text),
			key: text
		};
	});
}

function changeChapter(step: 'next' | 'previous') {
	const currentIndex = props.chapters.findIndex((c) => c === props.chapter);
	if (
		currentIndex === -1 ||
		(step === 'next' && currentIndex >= props.chapters.length - 1) ||
		(step === 'previous' && currentIndex <= 0)
	) {
		return '#';
	}
	const toChapter =
		step === 'next' ? props.chapters[currentIndex + 1] : props.chapters[currentIndex - 1];
	return toChapter;
}

async function fetchChapter(step: 'next' | 'previous') {
	const toChapter = changeChapter(step);
	if (toChapter !== '#') {
		emit('onFetch', toChapter);
	}
}

watch(
	() => props.chapter,
	(value) => (_chapter.value = value)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('flex items center justify-between gap-2 sm:gap-4 ' + (_ctx.className ?? ''))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Select), {
        value: _chapter.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_chapter).value = $event)),
        options: selectOptions(_ctx.chapters),
        placeholder: `Please select chapter`,
        class: "text-start min-w-[120px]",
        onChange: _cache[1] || (_cache[1] = (value) => emit('onFetch', value?.toString() ?? ''))
      }, null, 8, ["value", "options"]),
      _createVNode(_unref(RouterLink), { to: _ctx.homeURL }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), { type: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_unref(HomeOutlined))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.chapters.length === 0 || _ctx.chapters[0] !== _ctx.chapter)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: changeChapter('previous'),
            onclick: "return false"
          }, [
            _createVNode(_unref(Button), {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchChapter('previous')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(ArrowLeftOutlined)),
                  _hoisted_5
                ])
              ]),
              _: 1
            })
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.chapters.length === 0 || _ctx.chapters[_ctx.chapters.length - 1] !== _ctx.chapter)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: changeChapter('next'),
            onclick: "return false"
          }, [
            _createVNode(_unref(Button), {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (fetchChapter('next')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(ArrowRightOutlined))
                ])
              ]),
              _: 1
            })
          ], 8, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})